import React from 'react';
import './Marquee.scss';

const Marquee = () => {
    return (
        <div className="marquee">
            <div className="track">
                <p className="track__content">
                    &nbsp;Available to work! <span className="track__content-divider"/>
                    Get in touch <span className="track__content-divider"/>
                    Let's create something <span className="track__content_highlighted">Amazing!</span><span className="track__content-divider"/>
                    Available to work! <span className="track__content-divider"/>
                    Get in touch <span className="track__content-divider"/>
                    Let's create something <span className="track__content_highlighted">Amazing!</span><span className="track__content-divider"/>
                    Available to work! <span className="track__content-divider"/>
                    Get in touch <span className="track__content-divider"/>
                    Let's create something <span className="track__content_highlighted">Amazing!</span><span className="track__content-divider"/>
                    Available to work! <span className="track__content-divider"/>
                    Get in touch <span className="track__content-divider"/>
                    Let's create something <span className="track__content_highlighted">Amazing!</span><span className="track__content-divider"/>
                    Available to work! <span className="track__content-divider"/>
                    Get in touch <span className="track__content-divider"/>
                    Let's create something <span className="track__content_highlighted">Amazing!</span><span className="track__content-divider"/>
                </p>
            </div>
        </div>
    );
};

export default Marquee;
